import React, { useState } from 'react';

import { DisplayImage } from 'helper/products/meteorology';

import './index.scss';

export default function ImageColumns({
  imageSets,
  columnLabels,
  rowLabels,
}: {
  imageSets: DisplayImage[][];
  columnLabels: string[];
  rowLabels: string[];
}) {
  const [activeColumn, setActiveColumn] = useState(0);

  if (imageSets.length === 0) {
    return (
      <p className="image-columns-empty">
        Não foram encontradas imagens para os modelos selecionados
      </p>
    );
  }

  return (
    <div className="image-columns">
      <div className="image-columns-tabs">
        {columnLabels.map((label, i) => (
          <button
            key={label}
            type="button"
            className={`image-columns-tab${i === activeColumn ? ' active' : ''}`}
            onClick={() => setActiveColumn(i)}
          >
            {label}
          </button>
        ))}
      </div>
      <ul className="image-columns-list list-unstyled mb-0">
        {imageSets.map((imageSet, i) => {
          const image = imageSet[activeColumn];
          if (!image) return null;
          return (
            <li key={image.key} className="image-columns-card">
              {rowLabels[i] && (
                <span className="image-columns-card-label">{rowLabels[i]}</span>
              )}
              <img
                alt=""
                src={`data:image/png;base64,${image.base64}`}
                className="image-columns-card-image"
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
